import { render, staticRenderFns } from "./TabInfoOferta.vue?vue&type=template&id=52737fbc"
import script from "./TabInfoOferta.vue?vue&type=script&lang=js"
export * from "./TabInfoOferta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports